import React from 'react';

import i18n from '@nextroll/ar-i18n';

import { IWorkflow, WORKFLOW_BASE } from 'types/rofl';
import { workflowHasNotRun } from 'util/util';

import {
    AwaitingFirstRunTooltip,
    ViewLogTooltip,
} from '../WorkflowListTooltips/WorkflowListTooltips';

interface IProps {
    workflow: IWorkflow;
    actualUserRole?: string;
}

/**
 * Element for the Total Enrolled column, which may render the number of enrolled entities
 * or a label when the workflow has just launched.
 */
export const WorkflowTableTotalEnrolledCell = ({ workflow, actualUserRole }: IProps) => {
    if (workflowHasNotRun(workflow)) {
        return (
            <AwaitingFirstRunTooltip>
                <span className='workflows-workflow-list-first-run ar-label'>
                    <i className='far fa-clock' />
                    {i18n.gettext('Processing')}
                </span>
            </AwaitingFirstRunTooltip>
        );
    }

    return (
        <>
            <span className='workflow-table-total-enrolled-count'>
                {workflow.entity_type === WORKFLOW_BASE.ACCOUNTS ? (i18n.ngettext(
                    '{{ totalEnrolled }} account',
                    '{{ totalEnrolled }} accounts',
                    workflow.total_enrolled_entities,
                    { totalEnrolled: i18n.numeral(workflow.total_enrolled_entities).format('0,0') }
                )) : (i18n.ngettext(
                    '{{ totalEnrolled }} contact',
                    '{{ totalEnrolled }} contacts',
                    workflow.total_enrolled_entities,
                    { totalEnrolled: i18n.numeral(workflow.total_enrolled_entities).format('0,0') }
                ))}
            </span>
            <ViewLogTooltip
                base={workflow.entity_type || WORKFLOW_BASE.CONTACTS}
                totalEnrolled={workflow.total_enrolled_entities}
                createdAt={workflow.created_at}
                workflowEid={workflow.eid}
                advertisableEid={workflow.advertisable_eid}
                actualUserRole={actualUserRole}
            >
                <span data-testid={`${workflow.eid}-viewlog`} className='workflow-table-total-enrolled-view-log'>
                    {i18n.gettext('View Log')}
                </span>
            </ViewLogTooltip>
        </>
    );
};
